import { Wrapper } from './Wrapper';
import brandMapping from '@/utils/brandMapping';
import { ConditionalComponent } from './ConditionalComponent';
import type { PropsWithChildren, HTMLAttributes } from 'react';

type BandProps = {
  contentAlignment?: string;
  transforms?: string[];
  background?: string;
  contained?: boolean;
  outline?: boolean;
  swoosh?: string[];
  spacing?: string;
} & PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

export const Band = ({
  contentAlignment = 'left',
  background = '#ffffff',
  contained = false,
  spacing = 'large',
  transforms = [],
  outline = false,
  className = '',
  children,
  id,
}: BandProps) => (
  <Wrapper
    attributes={{
      background: brandMapping?.[background] || background,
      contentAlignment,
      transforms,
      contained,
      outline,
      spacing,
    }}
    className={className}
    id={id}
  >
    <ConditionalComponent className="band-container main-container" condition={contained} as="div">
      <div style={{ backgroundColor: brandMapping?.[background] || background }} className="band max-w-none">
        <div className="band-content [&>h2:first-child]:mt-0">{children}</div>
      </div>
    </ConditionalComponent>
  </Wrapper>
);
